import type { IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import type { PrimaryNavigationDestination } from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";

export type PrimaryNavigationDestinationPresentation = {
  icon: IconName;
  /** Glyph size of the resting strip icon. Learn's mortarboard reads larger, so it draws at 21. */
  iconSize: number;
  /** The destination's name under its strip icon, in the strip editor and in Settings. */
  label: string;
};

/**
 * How every destination looks in the primary navigation strip, its editor and the Settings
 * palette, so a tab never changes icon between the strip and the page that rearranges it.
 */
export const PRIMARY_NAVIGATION_DESTINATION_PRESENTATIONS = {
  browse: { icon: "MdGridView", iconSize: 22, label: "Browse" },
  changelog: { icon: "MdHistory", iconSize: 22, label: "Changelog" },
  collections: { icon: "MdCollectionsBookmark", iconSize: 22, label: "Collections" },
  cookbook: { icon: "MdMenuBook", iconSize: 22, label: "Cookbook" },
  decks: { icon: "GoStack", iconSize: 22, label: "Deck" },
  idioms: { icon: "HiChatBubbleLeftRight", iconSize: 22, label: "Idioms" },
  learn: { icon: "MdSchool", iconSize: 21, label: "Learn" },
  map: { icon: "MdMap", iconSize: 22, label: "Map" },
  search: { icon: "MdSearch", iconSize: 22, label: "Search" },
  settings: { icon: "MdSettings", iconSize: 22, label: "Settings" },
  stats: { icon: "MdInsights", iconSize: 22, label: "Stats" },
} as const satisfies Record<PrimaryNavigationDestination, PrimaryNavigationDestinationPresentation>;
